// src/components/ProtectedRoute.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useHeaderHeight from '../../hooks/useHeaderHeight';
import LoginModal from '../../modals/LoginModal';
import EmployeeLogin from '../EmployeeLogin';
import ForbiddenPage from '../ForbiddenPage';


const ProtectedRoute = ({
  component: Component,
  requiredRole,    // 'admin' or 'employee' or undefined
  ...rest
}) => {
  const sessionUser = useSelector(state => state.users.user);
  const isEmployeeUser = useSelector((state) => state.users?.user?.isEmployee || false);

  useHeaderHeight();





  const hasAccess = () => {
    if (!sessionUser) return false;
    if (sessionUser.isAdmin) return true;

    if (requiredRole) {
      if (requiredRole === 'admin') return false;
      if (requiredRole === 'employee') return !!isEmployeeUser;
      return false;
    }

    return true;
  };
  

  return (
    <Route
      {...rest}
      render={props => {
        if (!sessionUser) {
          // Staff routes get the passwordless staff sign-in; everything else
          // (admin /secure) keeps the admin magic-link modal.
          return requiredRole === 'employee' ? <EmployeeLogin /> : <LoginModal />;
        }
        if (!hasAccess())      return <ForbiddenPage />;
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
